import React from "react";
import "./Footer.css";

function Footer(props) {
  return (
    <footer>
      <div className="Footer">
        <div className="Footer__Note">
          <h2>childVision</h2>
          <p style={{ fontSize: "11pt" }}>
            Our target is to change the lives of 10 000 children by 2025.
          </p>
        </div>
        <div className="Footer__Usefullink">
          <h3>USEFULL LINK: </h3>
          <ul className="Footer__Link-Container">
            <li className="Footer__Links">
              <a className="Footer__Link">About</a>
            </li>
            <li className="Footer__Links">
              <a className="Footer__Link">Curiculum</a>
            </li>
            <li className="Footer__Links">
              <a className="Footer__Link">Gallery</a>
            </li>
          </ul>
        </div>
        <div className="Footer__Contacts">
          <h3>CONTACT US: </h3>

          {/* <p>Address</p> */}
          <p>Cell/WhatsApp: 0824541028</p>

          <p>Email: khanyisanitrust@gmail.com</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
